// Buyurtma tavsifi ("Number of rooms: 2; Problem description: ...") — eski mobil
// yozuvlar maydon nomlarini inglizcha saqlagan. Bu yerda faqat ma'lum label
// prefikslari ("Label:") o'zbekchaga almashtiriladi; bazadagi ma'lumot o'zgarmaydi.
// Admin panelning YAGONA tavsif formatlovchisi: ro'yxat, kartochka va tafsilot shuni ishlatadi.

const LABELS = {
  'number of rooms': 'Xonalar soni',
  'problem description': 'Muammo tavsifi',
  'problem type': 'Muammo turi',
};

// Qiymati mijoz yozgan erkin matn bo'lgan label'lar: undan keyingi matnga tegmaymiz.
const FREE_TEXT = new Set(['Muammo tavsifi']);

const SEGMENT_SEP = '; ';

export function formatOrderDescription(text) {
  if (typeof text !== 'string' || !text) return text;
  let out = '';
  let rest = text;
  for (;;) {
    const m = rest.match(/^([^:;]+):/);
    const uz = m && LABELS[m[1].trim().toLowerCase()];
    if (!uz) return out + rest;
    out += uz + ':';
    rest = rest.slice(m[0].length);
    if (FREE_TEXT.has(uz)) return out + rest;
    const i = rest.indexOf(SEGMENT_SEP);
    if (i < 0) return out + rest;
    out += rest.slice(0, i + SEGMENT_SEP.length);
    rest = rest.slice(i + SEGMENT_SEP.length);
  }
}
